(function (angular) {
  "use strict";

  angular.module('myApp').component('contactUs', {
    templateUrl: '/contactUs/contactUs.tpl.html',
    controller: [
      '$scope', '$http', 'aimSave','contactUsService',
      function ($scope, $http, aimSave, contactUsService) {

        $scope.aim = new aimSave();
        $scope.aim.serviceMethod = contactUsService.save;
        $scope.aim.dto.country = "United States";

        // Select 2 Script
        //setTimeout(function () {
          
        //  $("#countries").select2({
        //    templateSelection: formatState,
        //    templateResult: formatState
        //  });
        //}, 200);

      }
    ],
  });

}(window.angular));
